import { WaardelijstenApi } from "../../../api/waardelijsten";
import { Teksten } from "../../../content";
import { DropdownInfoFactory } from "../../../factories";
import { OrgMembershipsFactory } from "../../../factories/orgMemberships";
import { IdentifierWithChildren, WaardelijstFactory } from "../../../factories/waardelijst";
import { Identifier } from "../../../models";
import { Documenthandelingen } from "../../../models/document-metadata";
import { IdentifierMetAfkorting } from "../../../models/identifier";
import { IListValidator } from "../../../models/validator";
import {
  removeDocumentHandelingSoort,
  updateDocumentHandelingDate,
  updateDocumentHandelingOrganisatie,
  updateDocumentHandelingSoort,
} from "../../../store/reducers/document-metadata";
import { formatDate, stringToDate } from "../../../utils/DateFormatter";
import { WaardelijstCrawler } from "../../../utils/WaardelijstCrawler";
import { ContainerAtom, SpacerAtom } from "../../atoms";
import { IconButtonMolecule } from "../button";
import { SelectDropdownMolecule } from "../select-dropdown";
import { DateInputMolecule } from "../text-input";

interface Props {
  index: number;
  documenthandelingen: Documenthandelingen[];
  disableForm: boolean;
  dispatch: any;
  requiredRefs: HTMLInputElement[];
  requiredDropdownValidations: IListValidator[];
  factories: {
    waardelijsten: WaardelijstenApi;
    waardelijstFactory: WaardelijstFactory;
    orgMemberships: OrgMembershipsFactory;
    dropdownInfo: DropdownInfoFactory;
  };
  ksmOrganisaties: any[];
  documentDatums: string[];
  setDocumentDatums: (value: string[]) => void;
}

export function DocumenthandelingMolecule(props: Readonly<Props>) {
  const wasAssociatedWith: IdentifierMetAfkorting = WaardelijstCrawler.searchOrganisationAfkorting(
    props.documenthandelingen[props.index].wasAssociatedWith
  );

  return (
    <div key={"documentdatum_" + props.index} style={{ position: "relative" }}>
      <ContainerAtom>
        <SelectDropdownMolecule
          disabled={props.disableForm}
          key={Teksten.createScreen.wasAssociatedWith.id + props.index}
          onUpdated={(organisatie: Identifier) => {
            props.dispatch(
              updateDocumentHandelingOrganisatie({
                identifier: organisatie,
                index: props.index,
              })
            );
          }}
          selected={[
            {
              id: wasAssociatedWith.id,
              label: wasAssociatedWith.label,
            },
          ]}
          inputRef={(element: HTMLInputElement) => {
            if (props.documenthandelingen[props.index].wasAssociatedWith.id === "") props.requiredRefs.push(element);
          }}
          tekst={{
            ...Teksten.createScreen.wasAssociatedWith,
            label: "",
            id: Teksten.createScreen.wasAssociatedWith.id + props.index,
          }}
          singleSelect
          validations={props.requiredDropdownValidations}
          categories={props.factories.dropdownInfo.generateCategorlyListSelectFromList(
            {
              children: props.ksmOrganisaties,
            } as IdentifierWithChildren,
            [
              {
                id: wasAssociatedWith.id,
                label: wasAssociatedWith.label,
              },
            ],
            true
          )}
        />
        <SpacerAtom space={2} />
        <ContainerAtom type="row">
          <SelectDropdownMolecule
            disabled={props.disableForm}
            key={Teksten.createScreen.soortHandeling.id + props.index}
            tekst={{
              ...Teksten.createScreen.soortHandeling,
              label: "",
              id: Teksten.createScreen.soortHandeling.id + props.index,
            }}
            onUpdated={(handeling: Identifier) =>
              props.dispatch(updateDocumentHandelingSoort({ identifier: handeling, index: props.index }))
            }
            selected={[props.documenthandelingen[props.index].soortHandeling]}
            categories={props.factories.dropdownInfo.generateCategorlyListSelectFromList(
              props.factories.waardelijstFactory.createDocumenthandelingenLijst(),
              [props.documenthandelingen[props.index].soortHandeling]
            )}
            inputRef={(element: HTMLInputElement) => {
              if (props.documenthandelingen[props.index].soortHandeling.id === "") props.requiredRefs.push(element);
            }}
            validations={props.requiredDropdownValidations}
            singleSelect
            search={false}
          />
          <DateInputMolecule
            disabled={props.disableForm}
            required
            key={Teksten.createScreen.atTime.id + "_" + props.index + "_" + props.documentDatums[props.index]}
            id={Teksten.createScreen.atTime.id + "_" + props.index}
            defaultValue={props.documentDatums[props.index]}
            onBlur={(date: React.ChangeEvent<HTMLInputElement>) => {
              if (date.currentTarget.value && date.currentTarget.value !== "") {
                let newDates = props.documentDatums;
                newDates[props.index] = formatDate(stringToDate(date.currentTarget.value));
                props.setDocumentDatums(newDates);
                props.dispatch(
                  updateDocumentHandelingDate({
                    date: date.currentTarget.value,
                    index: props.index,
                  })
                );
              } else {
                date.currentTarget.value = formatDate(stringToDate(props.documentDatums[props.index]));
              }
            }}
          />
          {props.documenthandelingen.length > 1 && (
            <div style={{ maxWidth: "min-content" }}>
              <IconButtonMolecule
                id={"remove_handeling" + props.index}
                title={"Verwijder handeling"}
                icon={"icon-remove-blue"}
                type={"default"}
                size={"inputfieldSize"}
                disabled={props.disableForm}
                onClick={() => {
                  let dates = props.documentDatums;
                  dates.splice(props.index, 1);
                  props.setDocumentDatums(dates);
                  props.dispatch(removeDocumentHandelingSoort(props.index));
                }}
              />
            </div>
          )}
        </ContainerAtom>
      </ContainerAtom>
      {props.index !== props.documenthandelingen.length - 1 && <SpacerAtom space={4} />}
    </div>
  );
}
